const FeeReductionTypes: any = {
  FULL_FEE: 'Full fee amount',
  PARTIAL_FEE: 'Partial amount',
};

export default FeeReductionTypes;
